import React, { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { panelPath } from '../config/paths';

/** Eski /versions/:versionId/app-screens yolunu app-level app-screens’e yönlendirir. */
const AppScreensVersionRedirect: React.FC = () => {
  const { appId } = useParams<{ appId: string; versionId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!appId) return;
    navigate(panelPath(`/applications/${appId}/app-screens`), { replace: true });
  }, [appId, navigate]);

  if (!appId) return <Navigate to={panelPath('/applications')} replace />;
  return null;
};

export default AppScreensVersionRedirect;
